import { render, staticRenderFns } from "./DesktopNavbar.vue?vue&type=template&id=72d05800&"
import script from "./DesktopNavbar.vue?vue&type=script&lang=js&"
export * from "./DesktopNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports